import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
// THE SOCIAL LAYER (2026-10-25) - the same friends panel Terror carries; renders nothing until you are signed in.
import { SocialDock } from "./MarkChipSocial";   // the friends dock with its pill OFF: friends live inside the Mark chip (MarkCorner)
import MarkCorner from "./MarkCorner";
import Mark from "./Mark";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<React.StrictMode><App /><MarkCorner /><SocialDock game="tilt" accent="#4f9e9a" MarkView={Mark} /></React.StrictMode>);
